<template>
    <table class="infobox-table">
        <tbody>
            <tr>
                <td>
                    <v-img :src="getImageUrl(event)" width="100px" height="80px" class="preview-icons" />
                </td>
                <td>
                    <ListItemTitle :item="event" />
                </td>
                <td>
                    <span class="date-from"
                        >{{
                            event.first_schedule_date.isValid()
                                ? event.first_schedule_date.formatIf('dd, DD.MM.YYYY')
                                : ''
                        }}
                    </span>
                    <span v-if="event.last_schedule_date.isValid()" class="date-to"
                        >{{ $t('bis') }} <br />
                        {{ event.last_schedule_date.formatIf('dd, DD.MM.YYYY') }}
                    </span>
                </td>
                <td>
                    <span>{{ event.event_organizer }}</span>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import { globalVar } from '@/helpers/globals';
import { Event } from '@/models/Event';
import ListItemTitle from '@/components/event/list-item-title.vue';
export default {
    name: 'EventSmallInfoBox',
    components: { ListItemTitle },
    props: {
        event: {
            type: Event,
            required: true,
        },
    },

    methods: {
        getImageUrl(record) {
            const ts = new Date().getTime();
            const conf = globalVar('featured_images_config').event.thumb;
            return `${globalVar('imageroot')}/event/${record.id}/${conf.ident}.${conf.format}?ts=${ts}`;
        },
    },
};
</script>

<style lang="scss" scoped>
.infobox-table {
    width: 100%;
    background-color: var(--toolbar-bg-color);
    td {
        vertical-align: top;
        padding: 5px;
    }
}
</style>
